import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { Logo } from "@/components/news/Header";

export function AdminShell({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-muted/40">
      <header className="border-b bg-background">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
          <div className="flex items-center gap-3"><Logo /><span className="rounded bg-foreground px-2 py-0.5 font-mono-meta text-[10px] font-bold uppercase text-background">Admin</span></div>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden text-muted-foreground sm:inline">{user?.email}</span>
            <Link to="/" data-testid="admin-view-site-link" className="flex items-center gap-1 rounded-full px-3 py-2 font-semibold hover:bg-muted"><ExternalLink size={14} />Site</Link>
            <button data-testid="admin-logout-btn" onClick={logout} className="flex items-center gap-1 rounded-full px-3 py-2 font-semibold hover:bg-muted"><LogOut size={14} />Sair</button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">{children}</main>
    </div>
  );
}
